<template>
  <div class="sidebar" :style="sidebarStyle" :class="{ 'blockClass': $sidebar.showSidebar, 'noneClass': !$sidebar.showSidebar }"
  :data-color="backgroundColor" :data-image="backgroundImage">
    <div class="sidebar-wrapper">
      <div class="logo">
        <a href="/admin/overview" class="simple-text logo__container">
          <img class="logo-img"
            src="../../../assets/images/logo.png"
            alt="AlFursan logo">
          {{ title }}
        </a>
      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link, index) in sidebarLinks" :key="link.name + index" :to="link.path" @click="closeNavbar"
            :link="link">
            <p>{{ link.name }}</p>
            <i :class="link.icon"></i>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
import SidebarLink from './SidebarLink.vue'

export default {
  components: {
    SidebarLink
  },
  props: {
    title: {
      type: String,
      default: 'الفرسان'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: (value) => {
        let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    backgroundImage: {
      type: String,
      default: 'img/sidebar-5.jpg'
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    }
  }
}

</script>
<style>
.sidebar .sidebar-wrapper {
  display: flex;
  flex-direction: column;
}

.sidebar .nav-main__links {
  flex: 1;
}

.sidebar .sidebar-wrapper .logo .logo__container {
  padding-left: 10px;
}

.blockClass{
  display: block;
}
.main-panel{
  background-color: #F3F1F0 !important;
}


@media (max-width: 991px){
  .main-panel-none{
    display: none !important;
  }
  .noneClass{
    display: none !important;
  }
  .logo{
    display: none;
  }
  
}
</style>